import React from 'react';
import { Link, graphql, useStaticQuery } from 'gatsby';

import LinkBox from '../components/link-box';
import { getOtherAppearances } from '../utils/get-other-appearances';

const RecentEpisodes = () => {
  const data = useStaticQuery(graphql`
    query {
      allEpisodesJson {
        edges {
          node {
            id
            guest
            intro
            videoId
            publishedAt(formatString: "ddd, MMM D, YYYY")
            duration
            categories
            booksMentioned {
              title
            }
            fields {
              slug
            }
          }
        }
      }
    }
  `);

  return (
    <div>
      <div className="mb-5 flex flex-wrap justify-between items-center">
        <h3 className="whitespace-nowrap">Recent episodes</h3>{' '}
        <div className="text-lg border-b border-gray-600 whitespace-nowrap mt-3">
          <Link to="/episodes">Browse all →</Link>
        </div>
      </div>
      <div className="flex flex-col gap-4 mb-10 md:flex-row md:overflow-x-auto ">
        {data.allEpisodesJson.edges.slice(1, 7).map((edge, idx) => {
          const {
            id,
            guest,
            duration,
            categories,
            publishedAt,
            intro,
            videoId,
            booksMentioned,
            fields: { slug },
          } = edge.node || '';
          const otherAppearances = getOtherAppearances(
            id,
            guest,
            data.allEpisodesJson.edges
          );

          return (
            <div key={idx} className="relative flex-shrink-0">
              <img
                src={`https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`}
                alt={`${id} - ${guest}`}
                width="600"
                className="block rounded-lg"
              />
              <div className="bg-gray-900 bg-opacity-95 absolute top-0 left-0 w-full h-full opacity-0 hover:opacity-100 transition-opacity duration-500 p-5 flex flex-col items-start justify-items-center text-xs">
                <small className="mb-2 md:mb-1 text-sm text-gray-400">
                  {publishedAt}
                </small>
                <p className="text-lg mb-3 hidden md:block md:mb-5">{intro}</p>
                <div className="flex flex-wrap gap-2">
                  <LinkBox href={`/episodes/${slug}`}>Watch {duration}</LinkBox>
                  {booksMentioned && (
                    <LinkBox
                      href={`/episodes/${slug}`}
                      state={{ showBooks: true, hideVideo: true }}
                    >
                      Books mentioned
                    </LinkBox>
                  )}
                </div>
                <div className="hidden md:flex flex-wrap gap-2 items-center mt-3 md:mt-7">
                  {categories.map((category, idx) => (
                    <LinkBox
                      key={idx}
                      href={`/categories/${category.replace(/^\w+_/, '')}`}
                      variant="small"
                    >
                      #{category.replace(/^\w+_/, '')}
                    </LinkBox>
                  ))}
                </div>
                <div className="md:hidden flex flex-wrap gap-2 items-center mt-3 md:mt-7">
                  {categories.slice(0, 3).map((category, idx) => (
                    <LinkBox
                      key={idx}
                      href={`/categories/${category.replace(/^\w+_/, '')}`}
                      variant="small"
                    >
                      #{category.replace(/^\w+_/, '')}
                    </LinkBox>
                  ))}
                </div>
                <div className="md:mt-6">
                  {otherAppearances.length > 0 && (
                    <div className="mt-1 md:mt-2 mb-3 text-gray-400 text-lg">
                      Other appearances:{' '}
                      {otherAppearances.map((edge) => (
                        <div
                          className="inline mr-2 border-b border-gray-500"
                          key={`prev-${edge.node.id}`}
                        >
                          <Link to={`/episodes/${edge.node.fields.slug}`}>
                            {edge.node.id}
                          </Link>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RecentEpisodes;
